export default function RedFlagIco({ color }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_12335_217171)">
        <path
          d="M1 5.5C1 2.73858 3.23858 0.5 6 0.5H20C22.7614 0.5 25 2.73858 25 5.5V19.5C25 22.2614 22.7614 24.5 20 24.5H6C3.23858 24.5 1 22.2614 1 19.5V5.5Z"
          fill={color || "#7F56D9"}
          shape-rendering="crispEdges"
        />
        <path
          d="M13.7984 8.67387L13.0022 13.4519L12.2061 8.67387C12.187 8.55833 12.1933 8.44003 12.2245 8.32717C12.2557 8.2143 12.3111 8.10959 12.3869 8.02029C12.4626 7.93099 12.5569 7.85925 12.6632 7.81004C12.7694 7.76084 12.8851 7.73535 13.0022 7.73535C13.1193 7.73535 13.235 7.76084 13.3413 7.81004C13.4476 7.85925 13.5418 7.93099 13.6176 8.02029C13.6933 8.10959 13.7487 8.2143 13.78 8.32717C13.8112 8.44003 13.8175 8.55833 13.7984 8.67387Z"
          stroke="white"
          stroke-width="1.4296"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.0026 17.5835C13.3535 17.5835 13.6379 17.299 13.6379 16.9481C13.6379 16.5972 13.3535 16.3127 13.0026 16.3127C12.6517 16.3127 12.3672 16.5972 12.3672 16.9481C12.3672 17.299 12.6517 17.5835 13.0026 17.5835Z"
          fill="white"
          stroke="white"
          stroke-width="1.4296"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_12335_217171"
          x="0"
          y="0"
          width="26"
          height="26"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12335_217171"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12335_217171"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
